import React, { memo } from 'react'
import styles from './loader.module.css'

export interface LoaderProps {
    label?: string,
    size?: 'default' | 'large'
}

const BAR_COUNT = 5;

export const Loader = memo(({ label = 'Carregando...', size = 'default' }: LoaderProps) =>
(<div className={`${styles.loader} ${size === 'large' ? styles.large : ''}`} role='status' aria-live='polite'>
    <div className={styles.bars} aria-hidden='true'>
        {Array.from({ length: BAR_COUNT }, (_, i) => <span key={i} className={styles.bar} />)}
    </div>
    <span className={styles.label}>{label}</span>
</div>))

export default Loader;
